export default __webpack_public_path__ + "static/media/P946_RoHS.61d013a6.pdf";